import React, { useEffect, useState } from 'react';
import GroupManagement from '../components/sections/GroupManagement';
import { getGroups } from '../services/api';
import { toast } from 'react-toastify';

import { ItemGroupsData } from '../data/ItemGroupsData'
import { HelmetAsync } from '../utils/HelmetAsync';

function InventoryItems() {
    const [groups, setGroups] = useState([]);
    const [itemGroups, setItemGroups] = useState(ItemGroupsData);
    const [error, setError] = useState('');

    const addGroup = (groupName) => {
        setItemGroups([...itemGroups, { id: itemGroups.length + 1, name: groupName }]);
    };

    const editGroup = (id, newName) => {
        setItemGroups(itemGroups.map(group => 
            group.id === id ? { ...group, name: newName } : group
        ));
    };

    const deleteGroup = (id) => {
        setItemGroups(itemGroups.filter(group => group.id !== id));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getGroups();
                setGroups(response.groups);

                // toast.success('Groups Loaded successfully!');

            } catch (err) {
                setError(err.message || 'Failed to fetch group data');
                toast.error(err.message || 'Failed to fetch group data');
            }
        };
    
        fetchData();
    }, []); // Fetch data whenever issuesPage changes
    
    const title = `Item Groups - BreyERP`;

    return (
    <>
        <HelmetAsync title={title} />
        <GroupManagement
            // groups={groups}
            onAddGroup={addGroup}
            onEditGroup={editGroup}
            onDeleteGroup={deleteGroup}
        />
    </>
);
}

export default InventoryItems;